export default "__VITE_ASSET__B9Tny53w__"